import { render, staticRenderFns } from "./MenuWrapper.vue?vue&type=template&id=02e752cb&"
import script from "./MenuWrapper.vue?vue&type=script&lang=js&"
export * from "./MenuWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports